import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { Page, Header } from 'components'
import { useExameTentativaHomicidio } from './hooks/useExameTentativaHomicidio'
import { useStyles } from './ExameTentativaHomicidio.styles'
import { Form } from './components/Form'

export const ExameTentativaHomicidio = (props) => {
  const { route } = props
  const classes = useStyles()
  const {
    exameLocal,
    setExameLocal,
    processandoExameLocal,
    setProcessandoExameLocal,
    idExameRealizado,
  } = useExameTentativaHomicidio()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Box className={classes.results}>
        {exameLocal?.id && (
          <Form
            idExameSolicitado={exameLocal?.exReal?.id_exame_solicitado}
            exameLocal={exameLocal}
            setExameLocal={setExameLocal}
            setProcessandoExameLocal={setProcessandoExameLocal}
            processandoExameLocal={processandoExameLocal}
            idExameRealizado={idExameRealizado}
          />
        )}
      </Box>
    </Page>
  )
}

ExameTentativaHomicidio.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    secao: PropTypes.string,
  }).isRequired,
}

